import { useAuth0 } from '@auth0/auth0-react';
import { ChakraBox, ChakraText } from '@equip.health/ui';

import { PAGE_LAYOUT } from '~/lib/constants';

// TODO: Temporary props to display which dashboard the user has landed on.
interface DashboardProps {
  title: string;
}

const Dashboard = ({ title }: DashboardProps) => {
  const { user } = useAuth0();

  return (
    <ChakraBox
      alignItems="center"
      display="flex"
      flex="1 1 auto"
      flexDirection="column"
      height="100%"
      justifyContent="center"
      paddingRight={PAGE_LAYOUT.rightSpacing}
    >
      <ChakraText>
        Welcome {user.name} to the {title} Dashboard
      </ChakraText>
    </ChakraBox>
  );
};

export default Dashboard;
